/* UrbanDrop — scripts propios (sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll + cifras ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.ud-reveal, .ud-stock, [data-ud-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('ud-visible'); finalCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('ud-visible');
        if (el.hasAttribute('data-ud-count')) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function finalCount(el) {
    if (el.hasAttribute('data-ud-count')) el.textContent = el.getAttribute('data-ud-count');
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-ud-count'));
    if (isNaN(target)) { finalCount(el); return; }
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    if (window.udParallaxListo) return;
    var els = document.querySelectorAll('[data-ud-parallax]');
    if (!els.length || reduceMotion) return;
    window.udParallaxListo = true;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var intensity = parseFloat(el.getAttribute('data-ud-parallax')) || 0;
        var offset = (r.top + r.height / 2 - vh / 2) * intensity / 100;
        var rot = el.getAttribute('data-ud-rot') || '0';
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) rotate(' + rot + 'deg)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    var root = document.querySelector('[data-ud-pdp]');
    if (!root || root.hasAttribute('data-ud-listo')) return;
    root.setAttribute('data-ud-listo', '');

    // Galería
    var principal = root.querySelector('.ud-pdp__principal');
    var imgPrincipal = principal && principal.querySelector('img');
    root.querySelectorAll('.ud-pdp__mini').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.ud-pdp__mini').forEach(function (b) { b.classList.remove('is-activa'); });
        btn.classList.add('is-activa');
        if (!imgPrincipal) return;
        imgPrincipal.style.opacity = '0';
        setTimeout(function () {
          imgPrincipal.src = btn.getAttribute('data-src');
          imgPrincipal.removeAttribute('srcset');
          imgPrincipal.alt = btn.getAttribute('data-alt') || '';
          imgPrincipal.style.opacity = '1';
        }, 200);
        principal.classList.remove('is-zoom');
      });
    });
    if (principal) {
      principal.addEventListener('click', function (e) {
        var isZoom = principal.classList.toggle('is-zoom');
        if (isZoom && imgPrincipal) moveZoom(e);
      });
      principal.addEventListener('mousemove', function (e) {
        if (principal.classList.contains('is-zoom')) moveZoom(e);
      });
      principal.addEventListener('mouseleave', function () { principal.classList.remove('is-zoom'); });
    }
    function moveZoom(e) {
      var r = principal.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      imgPrincipal.style.transformOrigin = x + '% ' + y + '%';
    }

    // Variantes
    var dataEl = root.querySelector('[data-ud-variantes]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-ud-add]');
    var btnTxt = btn && btn.querySelector('[data-ud-add-txt]');
    var precioEl = root.querySelector('[data-ud-precio]');
    var antesEl = root.querySelector('[data-ud-precio-antes]');
    var avisoEl = root.querySelector('[data-ud-aviso]');
    var barraPrecio = document.querySelector('[data-ud-barra-precio]');
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
    var txtAdd = root.getAttribute('data-txt-add');
    var txtAgotado = root.getAttribute('data-txt-agotado');
    var umbral = parseInt(root.getAttribute('data-umbral'), 10) || 0;
    var txtPocas = root.getAttribute('data-txt-pocas') || '';

    function formatMoney(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var miles = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
    }

    function selected() {
      var opts = [];
      root.querySelectorAll('[data-ud-opcion]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        opts.push(c ? c.value : null);
      });
      return opts;
    }

    function update() {
      var opts = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnTxt) btnTxt.textContent = txtAgotado;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (precioEl) precioEl.textContent = formatMoney(v.price);
      if (barraPrecio) barraPrecio.textContent = formatMoney(v.price);
      if (antesEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          antesEl.textContent = formatMoney(v.compare_at_price);
          antesEl.hidden = false;
        } else { antesEl.hidden = true; }
      }
      if (btn) btn.disabled = !v.available;
      if (btnTxt) btnTxt.textContent = v.available ? txtAdd : txtAgotado;
      if (avisoEl) {
        var q = v.inventory_quantity;
        if (v.available && umbral > 0 && typeof q === 'number' && q > 0 && q <= umbral) {
          avisoEl.querySelector('span').textContent = txtPocas.replace('[n]', q);
          avisoEl.hidden = false;
        } else { avisoEl.hidden = true; }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-ud-opcion] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
    if (variants.length) update();

    // Añadir al carrito (abre el carrito lateral del tema si existe)
    var errorEl = root.querySelector('[data-ud-error]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // envío normal
        e.preventDefault();
        if (errorEl) errorEl.textContent = '';
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (errorEl) errorEl.textContent = res.description || res.message || '';
              return;
            }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            btn.removeAttribute('aria-busy');
            update();
          });
      });
    }

    // Barra fija móvil
    var barra = document.querySelector('[data-ud-barra]');
    if (barra && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var pasado = !en.isIntersecting && en.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', pasado);
        });
      }).observe(btn);
      var irBtn = barra.querySelector('[data-ud-ir]');
      if (irBtn) irBtn.addEventListener('click', function () {
        form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Chat de Shopify Inbox como pestaña lateral plegable ---------- */
  function initChatLateral() {
    var cfg = document.querySelector('[data-ud-chat-lateral]');
    if (!cfg || window.udChatLateral) return;
    window.udChatLateral = true;
    var intentos = 0;
    var timer = setInterval(function () {
      intentos++;
      var host = document.querySelector('shopify-chat');
      var sr = host && host.shadowRoot;
      var activador = sr && sr.querySelector('button.activator');
      if (!activador) { if (intentos > 40) clearInterval(timer); return; }
      clearInterval(timer);

      // Mueve el botón original del chat al lateral derecho y lo deja plegado:
      // solo asoma el icono y se despliega al pasar el ratón o el dedo.
      var plegado = 'position: fixed !important; top: 50% !important; bottom: auto !important; right: 0 !important; left: auto !important;' +
        'transform: translate(calc(100% - 48px), -50%) !important; transition: transform .45s cubic-bezier(.22,1,.36,1) !important; z-index: 61 !important;';
      var desplegado = 'transform: translate(0, -50%) !important;';
      var boton = 'border-radius: 14px 0 0 14px !important; box-shadow: 0 0 16px rgba(255,255,255,.35), 0 8px 24px rgba(0,0,0,.5) !important;';
      var st = document.createElement('style');
      st.textContent =
        '.activator-nudge {' + plegado + '}' +
        '.activator-nudge:hover, .activator-nudge:focus-within {' + desplegado + '}' +
        '.activator {' + boton + '}' +
        'shopify-agent-runtime::part(activator) {' + plegado + boton + '}' +
        'shopify-agent-runtime::part(activator):hover, shopify-agent-runtime::part(activator):focus-visible {' + desplegado + '}';
      sr.appendChild(st);
    }, 400);
  }

  function init() {
    initChatLateral();
    initReveals();
    initParallax();
    initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
